import styled from 'styled-components';

const StyledTextContainer = styled.span`
	position: relative;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: 500;
	color: #e6e6e6;
	user-select: none;
`;

export { StyledTextContainer };
